import { Box } from '@chakra-ui/react';
import { Fragment } from 'react';

import { LinkReference } from '@/components/ui/core/LinkReference/LinkReference';
import { useLecturePageQueryParams } from '@/components/ui/features/lecture/hooks';
import { queryArticlesByLectureId } from '@/fetchers/articles';
import { useResources } from '@/lib/datx-jsonapi-react';
import { Article } from '@/resources/Article';

export const LearnMorePanel = () => {
  const { id: lectureId } = useLecturePageQueryParams();
  const { data: articles } = useResources<Article>(queryArticlesByLectureId(lectureId));

  return (
    <Box>
      {articles && (
        <Fragment>
          {articles.map((article) => (
            <LinkReference key={article.id} title={article.title} url={article.url} />
          ))}
        </Fragment>
      )}
    </Box>
  );
};
